import I18n from 'I18n';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomViewsFallbackModeTooltip = ({
  disabled,
  children
}) => {
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !disabled,
    headingText: I18n.text('svh-workspace-ui-lib.custom-views.fallbackMode.navLinkHeader'),
    placement: "right",
    title: I18n.text('svh-workspace-ui-lib.custom-views.fallbackMode.navLinkText'),
    children: children
  });
};
CustomViewsFallbackModeTooltip.displayName = 'CustomViewsFallbackModeTooltip';
export default CustomViewsFallbackModeTooltip;